// extracted by mini-css-extract-plugin
export default {"heading":"J7UVWDFsOaVBgbDqf0W_","title":"hiS01_DBcdRLsy7jH4XA"};